const updateDiscountProgress = () => {
  const cartTotalPrice = document.querySelector('.cart-total-price').textContent;
  const progressElement = document.querySelector('.discount-progress .progress-bar progress');
  const discountMessageElement = document.querySelector('.discount-progress p');

  progressElement.value = cartTotalPrice;

  if (cartTotalPrice >= 10000) {
    discountMessageElement.textContent = 'You get 20% off! 🔥';
  } else if (cartTotalPrice >= 7500) {
    discountMessageElement.textContent = 'You get 15% off! 🎉';
  } else if (cartTotalPrice >= 3900) {
    discountMessageElement.textContent = 'You get 10% off!';
  } else {
    discountMessageElement.textContent = 'Unlock discounts as you add more items to your cart.';
  }
};

document.addEventListener('cart.update', updateDiscountProgress);